module.exports = __webpack_public_path__ + "static/media/white-caret-down.30c6c13b.svg";